<template>
  <div
    class="carousel-scroll-box"
    :key="chartKey"
    :ref="`carouselContainer${current.chartId}${type}`"
    :id="`carouselContainer${current.chartId}${type}`">
    <div class="content-wrapper" :ref="`carouselContentWrapper${current.chartId}${type}`">
      <div class="content" :ref="`carouselContent${current.chartId}${type}`">
        <p
          v-if="showScrollText"
          ref="contentText"
          class="carousel-text padding"
          :style="{color: contentColor, fontSize: current.showPropertiesHolder.fontSize}">
          {{showPropertiesHolder.showValue}}
        </p>
        <p
          class="carousel-text"
          :id="`carouselContent${current.chartId}${type}`"
          :style="{color: contentColor, fontSize: current.showPropertiesHolder.fontSize}">
          {{showPropertiesHolder.showValue}}
        </p>
      </div>
    </div>

  </div>
</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    name: "Carousel",
    data() {
      return {
        timer: null,
        chartKey: Math.random(),
        showScrollText: false,
      }
    },
    created() {
      if (this.current.showPropertiesHolder.dataType === 'FIELD') {
        const showHolder = this.current.showPropertiesHolder
        this.$store.dispatch('actionFilterFormData', {
          appId: showHolder.relateConfig.appId,
          formId: showHolder.relateConfig.formId,
          filterInfo: showHolder.relateConfig.filterInfo,
          advancedFilter: showHolder.relateConfig.advancedFilter,
          tableFieldId: showHolder.relateConfig.tableFieldId,
          advancedFilterInfo: showHolder.relateConfig.advancedFilterInfo,
          fieldId: showHolder.relateConfig.fieldId,
        }).then(res => {
          showHolder.showValue = res[showHolder.relateConfig.fieldId]
        }).catch(console.error)
      }
    },
    computed: {
      contentColor() {
        const contentColor = this.current.showPropertiesHolder.contentColor
        const parentContentColor = this.current.parent.styles.widget.colorInfo.contentColor
        return contentColor || parentContentColor
      },
    },
    mounted() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.resetFontSize()
          this.scrollText()
        }, 2000)
      })
    },
    beforeDestroy() {
      this.clearTimer()
    },
    methods: {
      scrollText() {
        this.showScrollText = false
        // const box = document.querySelector('.carousel-scroll-box')
        const box = this.$refs[`carouselContainer${this.current.chartId}${this.type}`]
        const content = document.querySelector('.content')
        // const text = document.querySelector('.carousel-text')
        const text =  document.querySelector(`#carouselContent${this.current.chartId}${this.type}`)
        let textWidth =  text.offsetWidth
        const boxWidth =  box.offsetWidth

        if (this.$refs[`carouselContent${this.current.chartId}${this.type}`]) {
          this.$refs[`carouselContent${this.current.chartId}${this.type}`].style.height = text.offsetHeight + 'px'
        }
        if (this.$refs[`carouselContentWrapper${this.current.chartId}${this.type}`]) {
          this.$refs[`carouselContentWrapper${this.current.chartId}${this.type}`].style.height = text.offsetHeight + 'px'
        }
        if(boxWidth > textWidth){
          if (this.$refs[`carouselContainer${this.current.chartId}${this.type}`]) {
            this.$refs[`carouselContainer${this.current.chartId}${this.type}`].style.justifyContent = this.current.showPropertiesHolder.textAlign
          }
          return false
        }
        this.showScrollText = true
        setTimeout(() => {
          // 更新
          const contentText = this.$refs.contentText
          if (contentText) contentText.style.paddingRight = boxWidth + 'px'
          textWidth = document.querySelector('.carousel-text').offsetWidth
          this.toScrollLeft(textWidth, box)
        }, 1000)
      },
      toScrollLeft(textWidth, box){
        //  如果文字长度大于滚动条距离，则递归拖动 + box.offsetWidth
        if(textWidth > box.scrollLeft){
          box.scrollLeft++
          this.timer = setTimeout(() => {
            this.toScrollLeft(textWidth, box)
          }, 18);
        } else{
          box.scrollLeft = 0
          this.toScrollLeft(textWidth, box)
        }
      },

      clearTimer() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
      },

      resetFontSize() {

        // this.$nextTick(() => {
        //   if (this.$refs.carouselContainer) {
        //     const containerWidth = document.querySelector(`#carouselContainer${this.current.chartId}${this.type}`).clientWidth
        //     const containerHeight = document.querySelector(`#carouselContainer${this.current.chartId}${this.type}`).clientHeight
        //     console.log('resize-containerWidth', document.querySelector(`#carouselContainer${this.current.chartId}${this.type}`), containerWidth, containerHeight)
        //
        //     const p = document.querySelector(`#carouselContent${this.current.chartId}${this.type}`)
        //     console.log('containerWidth', containerWidth, p)
        //     if (containerWidth < 300) {
        //       p.style.fontSize = '20px'
        //     } else if (containerWidth > 300 && containerWidth < 350) {
        //       p.style.fontSize = '24px'
        //     } else if (containerWidth > 350 && containerWidth < 400) {
        //       p.style.fontSize = '30px'
        //     } else if (containerWidth > 400 && containerWidth < 450) {
        //       p.style.fontSize = '35px'
        //     } else if (containerWidth > 450) {
        //       p.style.fontSize = '40px'
        //     }
        //
        //   }
        //
        // })
      },

      resize() {
        this.clearTimer()
        this.chartKey = Math.random()
        this.$nextTick(() => {
          setTimeout(() => {
            this.resetFontSize()
            this.scrollText()
          }, 1000)
        })
      },
      initChart() {
        this.resize()
      },
    },
    watch: {
      'showPropertiesHolder.showValue' () {
        this.resize()
      }
    }
  }
</script>

<style lang="less">

  .carousel-scroll-box {
    white-space: nowrap;
    overflow: hidden;
    display: flex;
    align-items: center;
    height: 100%;

    .content-wrapper {

    }

    .content, p{
      display:inline-block;
      overflow: hidden;

      .padding {
        /*padding-right: 850px;*/
      }
    }

    .carousel-text {
      margin: 0;
    }
  }

</style>
